export const Types = {
  Card: 'card',
};
